import { projectsRoutes, projectsNavigationItems } from "./router";
/**
 * Projects Module
 * Handles the funded-projects workflows (project records, donation allocations consultation).
 */
export class ProjectsModule {
    constructor() {
        Object.defineProperty(this, "contracts", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: null
        });
    }
    register(contracts) {
        this.contracts = contracts;
        contracts.logger.debug("[ProjectsModule] Registered");
        return {
            id: "projects",
            name: "Projects Module",
            version: "1.0.0",
        };
    }
    getRoutes() {
        return projectsRoutes;
    }
    getNavigationItems() {
        return projectsNavigationItems;
    }
    getComponent() {
        return null;
    }
    unregister() {
        this.contracts?.logger.debug("[ProjectsModule] Unregistered");
        this.contracts = null;
    }
}
export default new ProjectsModule();
